import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.875 2.75H4.125C3.36561 2.75 2.75 3.36561 2.75 4.125V17.875C2.75 18.6344 3.36561 19.25 4.125 19.25H17.875C18.6344 19.25 19.25 18.6344 19.25 17.875V4.125C19.25 3.36561 18.6344 2.75 17.875 2.75Z",
      stroke: "#1D2522",
      "stroke-width": "1.33",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.25065 10.5416C9.51629 10.5416 10.5423 9.51556 10.5423 8.24992C10.5423 6.98428 9.51629 5.95825 8.25065 5.95825C6.98501 5.95825 5.95898 6.98428 5.95898 8.24992C5.95898 9.51556 6.98501 10.5416 8.25065 10.5416Z",
      stroke: "#1D2522",
      "stroke-width": "1.33",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19.25 16.5001L14.2083 11.9167L9.625 16.0417L6.41667 13.2917L2.75 16.0417",
      stroke: "#1D2522",
      "stroke-width": "1.33",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }